<template>
  <input
    id="image-uploader"
    multiple
    type="file"
    class="hidden"
    v-bind="$attrs"
    @change="extractBase64($event)"
  />
  <Button size="small" @click="upload()" v-if="numImages < maxImages">
    Lägg till en bild
    <template #icon-after>
      <IconAdd />
    </template>
  </Button>

</template>

<script>
import Compressor from 'compressorjs';
import Button from '@/components/ui/button';
import IconAdd from '@/components/icons/IconAdd';
import {mapGetters} from "vuex";

export default {
  name: 'InputWithCompression',
  inheritAttrs: false,
  components: { Button, IconAdd },
  data() {
    return {
      //inputClasses : {},
      uploads: [],
    };
  },
  props: {
    /**
     * Hur ska den komprimeras? Skickas vidare till compressjs
     */
    compression: {
      type: [Number, Object, Array],
      default: { compression: 0.8 },
    },

    /**
     * Klasser på input-taggen
     */
    inputClasses: {
      type: Object,
      default: {},
    },

    /**
     * Ska "1 fil vald" visas?
     */
    showCounter: {
      type: Boolean,
      default: true,
    },

    numImages: {
      type: Number,
      default: 0,
    },

  },
  computed: {
    ...mapGetters({
      webapp_config: 'webapp_config',
    }),

    maxImages() {
        return this.webapp_config.msg.numPhotos ? this.webapp_config.msg.numPhotos : 2;
    },
    numberOfUploads() {
      return this.uploads.length / this.compressionObjects.length;
    },
    /**
     * Oavsett om man skickat in ett nummer, ett object eller en array ska man alltid få ut en array av compressions-inställningar
     */
    compressionObjects() {
      if (typeof this.compression == 'number') return [{ compression: this.compression }];

      if ((!this.compression) instanceof Array) return [this.compression];

      return this.compression.map((c) => {
        if (typeof c == 'number') return { compression: c };

        return c;
      });
    },
  },
  methods: {
    resultToBase64(fileReaderResult) {
      return fileReaderResult;
    },
    upload() {
      $('#image-uploader').click();
    },
    async extractBase64($event) {
      try {
        const files = Array.from($event.target.files);
        const allCompressedFiles = [];

        for (const file of files) {
          const compressedVersions = await Promise.all(
            this.compressionObjects.map((compression) => {
              return new Promise((resolve, reject) => {
                new Compressor(file, {
                  ...compression,
                  success: (result) => {
                    if (compression.toBase64) {
                      const reader = new FileReader();
                      reader.onload = () => {
                        resolve({ settings: compression, data: reader.result });
                      };
                      reader.onerror = (error) => reject(error);
                      reader.readAsDataURL(result);
                    } else {
                      resolve({ settings: compression, data: result });
                    }
                  },
                  error: (error) => reject(error),
                });
              });
            }),
          );
          allCompressedFiles.push(...compressedVersions);
        }

        this.uploads = allCompressedFiles;
        this.$emit('change', allCompressedFiles);
      } catch (error) {
        console.error('Error processing files:', error);
      }
    },
  },
};
</script>
